import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  NativeSelect,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { GREEN_COLOR, PURPLE_COLOR } from '../../../constants/ColorsConst';
import { saveArchivosAction } from '../../archivos/ArchivosAction';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';
import { VisuallyHiddenInput } from '../../usuario/usuarios/components/SettingsUsuarios';
import { oneCarnetAction } from '../CarnetAction';
import { ACTIVO_CARNET, STYLES_CARNET } from '../CarnetReducer';
import {
  BACKGROUND_COLOR_CONST,
  BORDER_COLOR_CONST,
  BORDER_RADIUS_CONST,
  BORDER_WIDTH_CONST,
  DISPLAY_CONST,
  FIRMA_STYLES_CONST,
  FONDO_BACK_STYLES_CONST,
  FONDO_STYLES_CONST,
  FONT_COLOR_CONST,
  FONT_FAMILY_CONST,
  FONT_SIZE_CONST,
  FONT_STYLE_CONST,
  FONT_WEIGHT_CONST,
  HEIGHT_CONST,
  LINE_HEIGHT_CONST,
  LOGO_LEFT_BACK_STYLES_CONST,
  LOGO_LEFT_STYLES_CONST,
  LOGO_RIGHT_BACK_STYLES_CONST,
  LOGO_RIGHT_STYLES_CONST,
  PARAMETRO1_STYLES,
  PARAMETRO2_STYLES,
  PHOTO_STYLES_CONST,
  SUBTITLE_BACK_STYLES_CONST,
  SUBTITLE_STYLES_CONST,
  TEXT_ALIGN_CONST,
  TEXT_BASELINE_CONST,
  TEXT_SHADOW_BLUR_CONST,
  TEXT_SHADOW_COLOR_CONST,
  TEXT_SHADOW_X_CONST,
  TEXT_SHADOW_Y_CONST,
  TITLE_AGE_STYLES_CONST,
  TITLE_BACK_STYLES_CONST,
  TITLE_FIRMA_STYLES_CONST,
  TITLE_NIVEL_STYLES_CONST,
  TITLE_SECCION_STYLES_CONST,
  TITLE_STYLES_CONST,
  WIDTH_CONST,
  X_CONST,
  Y_CONST,
  getIdTextComponent,
  getNameComponent,
  getNameStyles,
} from '../ConstCarnet';

const FormStylesCarnet = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const carnetStore = Redux.useSelector((state) => state.carnet);

  const [imagen, setImagen] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const activo = carnetStore.activo;
  const idComponent = carnetStore.stylesCarnet.id;
  const stylesComponent = carnetStore.stylesCarnet.styles;

  React.useEffect(() => {
    if (!activo.titleText || activo.titleText === '') {
      activo.titleText = entidadesStore.activo.nombre;
      dispatch({ type: ACTIVO_CARNET, payload: activo });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idComponent]);

  const _setValue = (key, value) => {
    dispatch({
      type: STYLES_CARNET,
      payload: {
        ...carnetStore.stylesCarnet,
        styles: { ...stylesComponent, [key]: value },
      },
    });
  };

  const upaloadFile = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.log('No file selected.');
      return;
    }

    setImagen(file.name);

    setLoading(true);
    const res = await saveArchivosAction(dispatch, {
      file: file,
      isPublic: 't',
      nameIdField: 'idCarnet',
      valueField: carnetStore.activo.id,
      field: getIdTextComponent(idComponent),
      desc: 'Imagen del carnet',
    });
    if (res) {
      setImagen(null);
      await oneCarnetAction(dispatch, carnetStore.activo.id);
    }
    setLoading(false);
  };

  const isImagen = [
    PHOTO_STYLES_CONST,
    LOGO_LEFT_STYLES_CONST,
    LOGO_RIGHT_STYLES_CONST,
    LOGO_LEFT_BACK_STYLES_CONST,
    LOGO_RIGHT_BACK_STYLES_CONST,
    FONDO_STYLES_CONST,
    FONDO_BACK_STYLES_CONST,
    FIRMA_STYLES_CONST,
  ].includes(idComponent);

  const isText = [
    TITLE_STYLES_CONST,
    SUBTITLE_STYLES_CONST,
    TITLE_BACK_STYLES_CONST,
    SUBTITLE_BACK_STYLES_CONST,
    TITLE_SECCION_STYLES_CONST,
    TITLE_NIVEL_STYLES_CONST,
    TITLE_AGE_STYLES_CONST,
    TITLE_FIRMA_STYLES_CONST,
    PARAMETRO1_STYLES,
    PARAMETRO2_STYLES,
  ].includes(idComponent);

  const isPhoto = idComponent === PHOTO_STYLES_CONST;
  const isFondo = [FONDO_STYLES_CONST, FONDO_BACK_STYLES_CONST].includes(
    idComponent,
  );

  if (isFondo) {
    return (
      <Box component="form">
        <Grid container spacing={2}>
          {isImagen && !isPhoto && (
            <Grid item xs={12} md={12}>
              <LoadingButton
                fullWidth
                loading={loading}
                sx={{
                  backgroundColor: GREEN_COLOR,
                  width: '100%',
                }}
                component="label"
                variant="contained"
                onChange={(e) => upaloadFile(e)}
                startIcon={<CloudUploadIcon />}
              >
                {loading ? 'Subiendo fondo...' : 'Subir fondo'}
                <VisuallyHiddenInput type="file" accept=".png, .jpg, .jpeg" />
              </LoadingButton>
              {imagen && <Avatar src={imagen} alt="fondocarnet" />}
            </Grid>
          )}
          <center>
            <img
              src={getFilesArchivos(activo[getIdTextComponent(idComponent)])}
              alt="imagen"
              style={{
                marginTop: '10px',
                width: '70%',
              }}
            />
          </center>
        </Grid>
      </Box>
    );
  }

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ fontSize: '10pt' }}
          >
            <strong>{getNameComponent(idComponent)}</strong>
          </Stack>
        </Grid>
        {isImagen && !isPhoto && (
          <Grid item xs={12} md={12}>
            <LoadingButton
              fullWidth
              loading={loading}
              sx={{
                backgroundColor: PURPLE_COLOR,
                width: '100%',
              }}
              component="label"
              variant="contained"
              onChange={(e) => upaloadFile(e)}
              startIcon={<CloudUploadIcon />}
            >
              {loading ? 'Subiendo imagén...' : 'Subir imagén'}
              <VisuallyHiddenInput type="file" accept=".png, .jpg, .jpeg" />
            </LoadingButton>
            {imagen && <Avatar src={imagen} alt="imagenLogo" />}
          </Grid>
        )}
        {isText && (
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              size="small"
              type="text"
              multiline
              rows={2}
              label={getNameComponent(getIdTextComponent(idComponent))}
              value={activo[getIdTextComponent(idComponent)] ?? ''}
              onChange={(e) => {
                if (TITLE_STYLES_CONST === idComponent) {
                  activo.titleText = e.target.value;
                } else if (SUBTITLE_STYLES_CONST === idComponent) {
                  activo.subtitleText = e.target.value;
                } else if (TITLE_BACK_STYLES_CONST === idComponent) {
                  activo.titleBackText = e.target.value;
                } else if (SUBTITLE_BACK_STYLES_CONST === idComponent) {
                  activo.subtitleBackText = e.target.value;
                } else if (TITLE_SECCION_STYLES_CONST === idComponent) {
                  activo.titleSeccionText = e.target.value;
                } else if (TITLE_NIVEL_STYLES_CONST === idComponent) {
                  activo.titleNivelText = e.target.value;
                } else if (TITLE_AGE_STYLES_CONST === idComponent) {
                  activo.titleAgeText = e.target.value;
                } else if (TITLE_FIRMA_STYLES_CONST === idComponent) {
                  activo.titleFirmaText = e.target.value;
                } else if (PARAMETRO1_STYLES === idComponent) {
                  activo.parametro1 = e.target.value;
                } else if (PARAMETRO2_STYLES === idComponent) {
                  activo.parametro2 = e.target.value;
                }
                dispatch({ type: ACTIVO_CARNET, payload: activo });
              }}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(WIDTH_CONST)}
            value={stylesComponent?.width ?? ''}
            onChange={(e) => {
              const value = Number(e.target.value);

              if (e.target.value === '') {
                _setValue(WIDTH_CONST, '');
              }

              if (value >= 0 && value <= 100) {
                _setValue(WIDTH_CONST, e.target.value ? value : '');
              }
            }}
            inputProps={{ min: 0, max: 100 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(HEIGHT_CONST)}
            value={stylesComponent?.height ?? ''}
            onChange={(e) => {
              _setValue(
                HEIGHT_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: 0, max: 100 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(X_CONST)}
            value={stylesComponent?.x ?? ''}
            onChange={(e) => {
              _setValue(X_CONST, e.target.value ? Number(e.target.value) : '');
            }}
            inputProps={{ min: -50, max: 100 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(Y_CONST)}
            value={stylesComponent?.y ?? ''}
            onChange={(e) => {
              _setValue(Y_CONST, e.target.value ? Number(e.target.value) : '');
            }}
            inputProps={{ min: -50, max: 100 }}
          />
        </Grid>
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label={getNameStyles(FONT_SIZE_CONST)}
              value={stylesComponent?.fontSize ?? ''}
              onChange={(e) => {
                _setValue(
                  FONT_SIZE_CONST,
                  e.target.value ? Number(e.target.value) : '',
                );
              }}
              inputProps={{ min: 8, max: 30 }}
            />
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="text"
              label={getNameStyles(FONT_COLOR_CONST)}
              value={stylesComponent?.fontColor ?? '#000000'}
              onChange={(e) => {
                _setValue(FONT_COLOR_CONST, e.target.value);
              }}
              inputProps={{ maxLength: 7 }}
            />
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="text"
              label={getNameStyles(FONT_FAMILY_CONST)}
              value={stylesComponent?.fontFamily ?? ''}
              onChange={(e) => {
                _setValue(FONT_FAMILY_CONST, e.target.value.toString());
              }}
            />
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                {getNameStyles(FONT_STYLE_CONST)}
              </InputLabel>
              <NativeSelect
                defaultValue={stylesComponent?.fontStyle ?? 'normal'}
                inputProps={{
                  name: getNameStyles(FONT_STYLE_CONST),
                  id: 'native-fontstyle',
                }}
                onChange={(e) => {
                  _setValue(FONT_STYLE_CONST, e.target.value);
                }}
              >
                <option value="normal">Normal</option>
                <option value="italic">Cursiva</option>
              </NativeSelect>
            </FormControl>
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                {getNameStyles(FONT_WEIGHT_CONST)}
              </InputLabel>
              <NativeSelect
                defaultValue={stylesComponent?.fontWeight ?? 'normal'}
                inputProps={{
                  name: getNameStyles(FONT_WEIGHT_CONST),
                  id: 'native-fontweigth',
                }}
                onChange={(e) => {
                  _setValue(FONT_WEIGHT_CONST, e.target.value);
                }}
              >
                <option value="normal">Normal</option>
                <option value="bold">Negrita</option>
              </NativeSelect>
            </FormControl>
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                {getNameStyles(TEXT_ALIGN_CONST)}
              </InputLabel>
              <NativeSelect
                defaultValue={stylesComponent?.textAlign ?? 'center'}
                inputProps={{
                  name: getNameStyles(TEXT_ALIGN_CONST),
                  id: 'native-fontweigth',
                }}
                onChange={(e) => {
                  _setValue(TEXT_ALIGN_CONST, e.target.value);
                }}
              >
                <option value="left">Izquierda</option>
                <option value="center">Centro</option>
                <option value="right">Derecha</option>
                <option value="justify">Justificado</option>
              </NativeSelect>
            </FormControl>
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                {getNameStyles(TEXT_BASELINE_CONST)}
              </InputLabel>
              <NativeSelect
                defaultValue={stylesComponent?.textBaseline ?? 1}
                inputProps={{
                  name: getNameStyles(TEXT_BASELINE_CONST),
                  id: 'native-baseline',
                }}
                onChange={(e) => {
                  _setValue(TEXT_BASELINE_CONST, e.target.value);
                }}
              >
                <option value="middle">Arriba</option>
                <option value="center">Centro</option>
                <option value="bottom">Abajo</option>
              </NativeSelect>
            </FormControl>
          </Grid>
        )}
        {!isImagen && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label={getNameStyles(LINE_HEIGHT_CONST)}
              value={stylesComponent?.lineHeight ?? ''}
              onChange={(e) => {
                _setValue(
                  LINE_HEIGHT_CONST,
                  e.target.value ? Number(e.target.value) : '',
                );
              }}
              inputProps={{ min: 0, max: 10 }}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="text"
            label={getNameStyles(BACKGROUND_COLOR_CONST)}
            value={stylesComponent?.backgroundColor ?? ''}
            onChange={(e) => {
              _setValue(BACKGROUND_COLOR_CONST, e.target.value.toString());
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="text"
            label={getNameStyles(BORDER_COLOR_CONST)}
            value={stylesComponent?.borderColor ?? ''}
            onChange={(e) => {
              _setValue(BORDER_COLOR_CONST, e.target.value.toString());
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(BORDER_RADIUS_CONST)}
            value={stylesComponent?.borderRadius ?? ''}
            onChange={(e) => {
              _setValue(
                BORDER_RADIUS_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: 0, max: 100 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(BORDER_WIDTH_CONST)}
            value={stylesComponent?.borderWidth ?? ''}
            onChange={(e) => {
              _setValue(
                BORDER_WIDTH_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: 0, max: 10 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(TEXT_SHADOW_X_CONST)}
            value={stylesComponent?.textShadowX ?? ''}
            onChange={(e) => {
              _setValue(
                TEXT_SHADOW_X_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: -10, max: 10 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(TEXT_SHADOW_Y_CONST)}
            value={stylesComponent?.textShadowY ?? ''}
            onChange={(e) => {
              _setValue(
                TEXT_SHADOW_Y_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: -10, max: 10 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label={getNameStyles(TEXT_SHADOW_BLUR_CONST)}
            value={stylesComponent?.textShadowBlur ?? ''}
            onChange={(e) => {
              _setValue(
                TEXT_SHADOW_BLUR_CONST,
                e.target.value ? Number(e.target.value) : '',
              );
            }}
            inputProps={{ min: 0, max: 10 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="text"
            label={getNameStyles(TEXT_SHADOW_COLOR_CONST)}
            value={stylesComponent?.textShadowColor ?? ''}
            onChange={(e) => {
              _setValue(TEXT_SHADOW_COLOR_CONST, e.target.value.toString());
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            label={getNameStyles(DISPLAY_CONST)}
            labelPlacement="start"
            control={
              <Switch
                checked={stylesComponent?.display === 'block'}
                onChange={(event) => {
                  _setValue(
                    DISPLAY_CONST,
                    event.target.checked ? 'block' : 'none',
                  );
                }}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormStylesCarnet;
